export const urlValidator = value =>
  value && !/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/i.test(value)
    ? 'Invalid email address'
    : undefined;
